<template>
	<div class="bg">
		<div class="container">
			<div class="tit">申请加盟</div>
			<div class="row">
				<div class="col-6 col-sm-4">
					<div class="inp"><input type="text" placeholder="姓名：" v-model="name" /></div>
				</div>
				<div class="col-6 col-sm-4">
					<div class="inp"><input type="text" placeholder="年龄：" v-model="age" /></div>
				</div>
				<div class="col-6 col-sm-4">
					<div class="inp_radio">
						<span>性别：</span>
						<input @click="getRadioVal(0)" type="radio" style="width: 20px;height: 20px;vertical-align: middle;margin-left: 15px;" name="radio" value="男" checked /> 男
						<input @click="getRadioVal(1)" type="radio" style="width: 20px;height: 20px;vertical-align: middle;margin-left: 15px;" name="radio" value="女" /> 女
					</div>
				</div>
				<div class="col-6 col-sm-4">
					<div class="inp"><input type="text" placeholder="电话：" v-model="telephone" /></div>
				</div>
				<div class="col-6 col-sm-4">
					<div class="inp"><input type="text" placeholder="手机：" v-model="mobilePhone" /></div>
				</div>
				<div class="col-6 col-sm-4 none">
					<div class="inp"><input type="text" placeholder="QQ：" v-model="qq" /></div>
				</div>
				<div class="col-6 col-sm-4">
					<div class="inp"><input type="text" placeholder="邮箱：" v-model="email" /></div>
				</div>
				<div class="col-6 col-sm-4">
					<div class="inp"><input type="text" placeholder="店面面积：" v-model="shopArea" /></div>
				</div>
				<div class="col-6 col-sm-4">
					<div class="inp"><input type="text" placeholder="有无建材经营产品/品牌：" v-model="saleBrand" /></div>
				</div>
				<div class="col-12">
					<div class="inp"><input type="text" placeholder="意向代理地区/城市" v-model="intentionArea" /></div>
				</div>
				<div class="col-12 none">
					<div class="inp"><textarea type="text" placeholder="请在此处留言：" v-model="leaveMessage" /></div>
				</div>
			</div>
			<div class="row">
				<div class="col-6 offset-3">
					<div class="btn" @click="getApplyJoin" :data-toggle="isModal" data-target="#myModal">提交{{name}}</div>
				</div>
			</div>
			<!-- 模态框 -->
			<div class="modal fade" id="myModal">
				<div class="modal-dialog" >
					<div class="modal-content">

						<!-- 模态框头部 -->
						<div class="modal-header">
							<h4 class="modal-title">提示</h4>
							<button type="button" class="close" data-dismiss="modal">&times;</button>
						</div>

						<!-- 模态框主体 -->
						<div class="modal-body">
                             {{msg}}
						</div>

						<!-- 模态框底部 -->
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">关闭</button>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import API from '@/components/api/home'
	export default {

		data() {
			return {
				isModal:'modal',
				name: '',
				age: '',
				gender: 0,
				telephone: '',
				mobilePhone: '',
				qq: '',
				email: '',
				shopArea: '',
				saleBrand: '',
				intentionArea: '',
				leaveMessage: '',
				msg: '',
			}
		},
		mounted() {

		},
		methods: {
			getRadioVal(value) {
				this.gender = value
			},
			//提交数据
			getApplyJoin() {
				let that = this
				let params = {}
				params.name = that.name //是	String	姓名
				params.age = that.age //是	Integer	年龄
				params.gender = that.gender //是	Integer	性别传数字类型；0为男；1为女
				params.telephone = that.telephone //是	String	电话
				params.mobilePhone = that.mobilePhone //是	String	手机
				params.qq = that.qq //String	qq号码 
				params.email = that.email //是	String	邮箱
				params.shopArea = that.shopArea //是	String	店面面积
				params.saleBrand = that.saleBrand //是	String	建材经营产品/品牌
				params.intentionArea = that.intentionArea //是	String	意向代理地区/城市
				params.leaveMessage = that.leaveMessage //	留言
				console.log(params)
				API.getApplyJoin(params).then(res => {
					console.log(res)
					that.msg = res.msg
					console.log(that.msg)
				})
			}
		},
	}
</script>

<style scoped lang="less">
	@w: 19.2vw;
	.bg {
		background: url("../../../static/images/inputBg.png") no-repeat center;
		background-size: 100% 100%;
		padding: 50/@w 0;
		width: 100%;
		font-size: 18/@w;
		.tit {
			text-align: center;
			color: #FBF4E9;
			font-weight: bold;
		}
		.inp {
			position: relative;
			margin-top: 50/@w;
			&:after {
				content: "*";
				color: red;
				position: absolute;
				left: 8px;
				top: 30%;
			}
			input,
			textarea {
				width: 100%;
				height: 100%;
				background: #FBF4E9;
				border-radius: 10px;
				border: 0;
				padding: 12/@w 20px;
				outline: none;
				box-sizing: border-box;
				min-height: 25px;
				color: #6A6A6A;
			}
			textarea {
				height: 240/@w;
				min-height: 100px;
				resize: none;
			}
		}
		.none {
			.inp {
				&:nth-last-child(1) {
					&:after {
						content: "";
					}
				}
			}
		}
	}
	
	.inp_radio {
		color: #FBF4E9;
		font-size: 18/@w;
		margin-top: 55/@w;
	}
	
	.btn {
		text-align: center;
		background: #166BAB;
		color: #FBF4E9;
		padding: 15/@w;
		width: 100%;
		margin-top: 50/@w;
		border-radius: 10px;
		font-size: 18/@w;
		cursor: pointer;
	}
	.modal-dialog {
	    margin: 200px auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/inputBtn/index.vue